export default {
  path: '/users',
  name: 'users',
  redirect: { name: 'users.all' },
  component: () => import(/* webpackChunkName: "users" */ '@/views/Home/Users'),
  children: [
    {
      path: 'all',
      name: 'users.all',
      component: () =>
        import(/* webpackChunkName: "users" */ '@/views/Home/Users/AllUsers')
    },
    {
      path: 'onboarding',
      name: 'users.onboarding',
      component: () =>
        import(
          /* webpackChunkName: "users" */ '@/views/Home/Users/NewlyRegisteredUsers'
        )
    },
    {
      path: 'verified',
      name: 'users.verified',
      component: () =>
        import(
          /* webpackChunkName: "users" */ '@/views/Home/Users/VerifiedUsers'
        )
    },
    {
      path: 'unverified',
      name: 'users.unverified',
      component: () =>
        import(
          /* webpackChunkName: "users" */ '@/views/Home/Users/UnverifiedUsers'
        )
    }
  ]
}
